import { render, staticRenderFns } from "./projectPublishForm.vue?vue&type=template&id=b65f2bd0"
import script from "./projectPublishForm.vue?vue&type=script&lang=js"
export * from "./projectPublishForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports